import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowsImIn from './FlowsImIn';

const FlowsImInBridge = react2angular(FlowsImIn);

export default FlowsImInBridge;
